import { setPublicUserInfo } from '../../redux/reducers/publicUser/reducer';

import { authService } from '../../shared/services/authService';

export const logout = async () => {
  const { store } = await import('../../redux/store');
  authService.removeAccessToken();
  store.dispatch(setPublicUserInfo(undefined));
};
